import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input"];

    connect() {
        this.form = this.element; // Przypisanie formularza
        this.form.addEventListener("submit", (event) => this.handleSubmit(event)); // Obsługa submit
        this.inputTargets.forEach((input) => {
            // Nasłuchiwacz zdarzenia "input" dla każdego pola formularza
            input.addEventListener("input", () => this.handleInput(input));
        });
    }

    handleSubmit(event) {
        let isValid = true;
        this.inputTargets.forEach((input) => {
            if (!this.validateInput(input)) {
                isValid = false;
            }
        });

        // Jeśli formularz jest nieprawidłowy, nie wysyłaj go
        if (!isValid) {
            event.preventDefault();
        }
    }

    handleInput(input) {
        // Jeśli wartość jest poprawna, usuwamy komunikat o błędzie
        if (this.validateInput(input)) {
            const errorMessage = input.parentElement.querySelector(".invalid-feedback");
            errorMessage.textContent = "";
            input.classList.remove("is-invalid");
        }
    }

    validateInput(input) {
        const errorMessage = input.parentElement.querySelector(".invalid-feedback");

        // Resetowanie komunikatów o błędach
        if (!input.checkValidity()) {
            input.classList.add("is-invalid");
            errorMessage.textContent = input.validationMessage; // Domyślny komunikat walidacji
            return false;
        }
        return true;
    }
}
